import script from "./HollowCandles.vue?vue&type=script&lang=js"
export * from "./HollowCandles.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__